import type { DefaultTheme } from 'styled-components';

import { hexToRGB } from '@/styles/helpers';

export const termsBgConfig: Record<string, (theme: DefaultTheme) => string> = {
  gray: (theme) => hexToRGB(theme.whiteColor, 0.2),
  dark: (theme) => theme.grayDarkColor,
};
